<template>
  <div
    class="h-tab"
    :class="{ 'h-tab--active': activeTab === name }"
    role="tab"
    aria-label="tab"
    @click="handleSelectTab(name)"
  >
    <div class="h-tab__tab">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  inject: ['handleSelectTab', 'activeTab'],
  props: {
    name: { type: String, default: undefined }
  }
}
</script>
<style lang="scss" scoped>
.h-tab {
  margin-right: var(--gl-spacing-02);
  padding: var(--gl-spacing-02) var(--gl-spacing-03);
  display: flex;
  align-items: center;
  gap: var(--gl-spacing-02);
  cursor: pointer;
  border-radius: var(--gl-spacing-02);

  &__tab {
    max-height: 32px;
    display: flex;
    align-items: center;
    gap: var(--gl-spacing-02);
    color: var(--sys-color-content-primary);
    font-size: var(--web-font-size-1125);
    font-weight: var(--gl-font-weight-semibold);
    line-height: var(--web-line-height-rule-05);
    letter-spacing: var(--gl-letter-spacing-rule-01);
  }

  &--active {
    border-bottom: var(--gl-border-width-md) solid var(--sys-color-stroke-focus);
    border-radius: var(--gl-spacing-02) var(--gl-spacing-02) 0 0;
  }

  &:hover {
    background-color: var(--sys-color-surface-container-hover);
  }

  &:active {
    background-color: var(--gl-color-shades-gray-20);
  }
}
</style>
